<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_TASK_INSERT')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm mới tiểu mục công việc</h1>
      <div style="float: right">
        <button class="btn btn-light" @click="cancelModal = true">Hủy bỏ</button>
        <button class="btn btn-success btn-primary ml-2" @click="confirmAdd">Thêm mới</button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 row">
        <ValidationObserver class="w-100" ref="formAdd">
          <form class="col-md-6" @submit.prevent="confirmAdd">
            <ValidationProvider rules="required|inputLimit50" vid="code" name="Mã tiểu mục">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Mã tiểu mục<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input
                    v-model="dataInsert.code"
                    type="text"
                    class="form-control"
                    placeholder="Nhập mã tiểu mục"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|minMaxName_2" vid="name" name="Tên tiểu mục">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên tiểu mục<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input
                    v-model="dataInsert.name"
                    type="text"
                    class="form-control"
                    placeholder="Nhập tên tiểu mục"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <div class="form-group row">
              <label for="" class="col-sm-4 col-form-label">Nhóm công việc</label>
              <div class="col-sm-8">
                <Select2
                  v-model="type"
                  :options="typeOptions"
                  placeholder="Chọn nhóm công việc"
                  @change="getListCategory"
                />
              </div>
            </div>

            <ValidationProvider rules="required" vid="taskCode" name="Danh mục">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Danh mục<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <Select2
                    v-model="dataInsert.taskCode"
                    :disabled="loadCat"
                    :options="listCat"
                    placeholder="Danh mục"
                  ></Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <b-modal id="modal-scoped" v-model="showModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button variant="light" @click="close()" v-if="errorAdd"> Đóng </b-button>
        <b-button variant="light" @click="backToList" v-else> Đóng </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-scoped" v-model="addModal">
      <template #modal-header="{ close }">
        <h5>Thêm tiểu mục công việc</h5>
        <b-button variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn thêm tiểu mục công việc này ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button variant="light" @click="close()"> Đóng </b-button>
        <b-button variant="primary" @click="confirmAdd"> Xác nhận </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-scoped" v-model="cancelModal">
      <template #modal-header="{ close }">
        <h5>Huỷ thêm tiểu mục công việc</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn huỷ ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="backToList"> Xác nhận </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { mapGetters } from 'vuex'
  import { WorkGroupList } from '@/services/customer-support/task'
  export default {
    data() {
      return {
        dataInsert: {},
        msgNoti: '',
        iconNoti: '',
        showModal: false,
        errorAdd: false,
        addModal: false,
        cancelModal: false,
        tLoadOwner: null,
        typeOptions: [],
        listCat: [],
        loadCat: false,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    created() {
      this.loadDataType()
    },
    methods: {
      async getListCategory(id) {
        this.loadCat = true
        try {
          const res = await CalendarAfsService.catCalendar({
            wkGroupId: id,
            page: 1,
            size: 1000,
          })
          if (res.code === 1000) {
            this.listCat =
              res.data.map(item => {
                return {
                  id: item.taskCode || '',
                  text: item.taskName || '',
                }
              }) || []
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.loadCat = false
        }
      },
      async loadDataType() {
        try {
          const res = await WorkGroupList({
            size: 1000,
            page: 1,
            status: 'APPLYING',
            // applyFor: 'CV_CS'
          })
          if (res.code === 1000) {
            this.typeOptions = res.data.map(item => {
              return {
                id: item.id,
                text: item.groupName,
                code: item.groupCode,
              }
            })
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.isLoading = false
        }
      },
      // add tiểu mục
      async addSubItem() {
        this.addModal = true
      },
      async confirmAdd() {
        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) {
          return
        }
        // this.addModal = false
        try {
          const data = await CalendarAfsService.addWorkSubsection(this.dataInsert)
          if (data.code === 1000) {
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Thêm tiểu mục công việc thành công'
            this.errorAdd = false
          } else {
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.errorAdd = true
          }
        } catch (error) {
          console.log(error)
          this.showModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Có lỗi xảy ra, vui lòng thử lại'
          this.errorAdd = true
        }
      },
      backToList() {
        this.$router.push('/work-subsection-afs')
      },
    },
  }
</script>
